(function($) {

	'use strict';

	var init = function() {

        manageHeaderBand();

    };
    
    var manageHeaderBand = function() {

        var content = $('.header__info__content span:first-child').html();
        $('<span>'+ content + '</span>').insertAfter('.header__info__content span:first-child');



        var headbandContent = $('.header__info__content span:first-child').width();
        var headband = $('.defileParent').width();
        var speed = ( headbandContent / headband ) * 20;

        $('.defile span').css('animation-duration', speed + 's');
        $('.defile span').css('animation-play-state', 'running');

        if(sessionStorage.getItem('isVisible') == null) {
            $('.header__info').addClass('active');
        }

        $('.header__info__close').click(function() {
            $('.header__info').removeClass('active');
            setTimeout(function() {
                $('.header__info').remove();
            }, 400);
            sessionStorage.setItem('isVisible', 'hidden');
        });

    }

	$(window).on('load', function() {
		init();
	});

})(jQuery);